import { useState, useEffect } from 'react';

const CountDown = ({ seconds, onComplete }) => {
  const [timer, setTimer] = useState(seconds);

  useEffect(() => {
    let timerFunc;
    timer > 0 ? timerFunc = setTimeout(() => setTimer(timer - 1), 1000) : onComplete();
    return () => {
      clearTimeout(timerFunc);
    }
  }, [onComplete, seconds, timer]);

  return timer;
}

export default CountDown;
